module.exports = __webpack_public_path__ + "static/media/signage-industrial-img2.4103bde8.jpg";